import { Fragment, useMemo } from "react";

import { Element } from "@craftjs/core";

import { DnDBypassProvider } from "@/components/builder/utils/bypass-context";

import { MidpathTCPAAnswersBlock, MidpathTCPAConsentBlock, MidpathTCPAContinueContainerBlock, MidpathTCPAErrorFeedbackBlock, MidpathTCPAQuestionTitleBlock } from "../..";
import { define, prop } from "../../../utils";
import BasePreview from "../../base";
import { useTCPAQuestion } from "../context";

function TCPAQuestionPreview(props) {
  const tcpaquestion = useTCPAQuestion()

  const consentBefore = useMemo(() => ({ position: 'before' }), [])
  const consentAfter = useMemo(() => ({ position: 'after' }), [])

  if (!tcpaquestion) return null

  const { answers, isMultipleAnswers, consentTextActive, consentPosition, required, manualSubmit } = tcpaquestion

  return <>
    <form className="tcpa-questionary-form">
      <BasePreview {...props}>
        <div className="tcpa-questionary">
          <Element is={MidpathTCPAQuestionTitleBlock} id={`tcpa-question-title`} />
          <DnDBypassProvider data={consentBefore}>
            {consentTextActive && ['before', 'both'].includes(consentPosition) ? <Element is={MidpathTCPAConsentBlock} id={`tcpa-consent`} properties={{ position: 'before' }} /> : null}
          </DnDBypassProvider>
          <TCPAAnswers answers={answers} isMultipleAnswers={isMultipleAnswers} />
          {required || manualSubmit ? <Element is={MidpathTCPAErrorFeedbackBlock} id={`tcpa-error-feedback`} /> : null}
          {isMultipleAnswers ? <Element is={MidpathTCPAContinueContainerBlock} id='tcpa-continue-container' /> : null}
          <DnDBypassProvider data={consentAfter}>
            {consentTextActive && ['after', 'both'].includes(consentPosition) ? <Element is={MidpathTCPAConsentBlock} id={`tcpa-consent`} properties={{ position: 'after' }} /> : null}
          </DnDBypassProvider>
        </div>
      </BasePreview>
    </form>
  </>
}

function TCPAAnswers({ answers, isMultipleAnswers }) {
  return <DnDBypassProvider data={useMemo(() => ({ isMultipleAnswers, answers }), [answers, isMultipleAnswers])}>
    <Element is={MidpathTCPAAnswersBlock} id={`tcpa-answers`} />
  </DnDBypassProvider>
}

export default define('tcpa-questionary', TCPAQuestionPreview, Fragment)
  .shared(prop.share('MidpathTCPAQuestion', 'tcpa-questionary'), { prefix: false })
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    customClassName: ["container", "max-w-lg"],
    'customClassName-options': [{ label: "container", value: "container" }, { label: "max-w-lg", value: "max-w-lg" }],
    layoutType: "flex",
    flex: {
      direction: "flex-col",
      gap: "4",
    },
  })
  .build()
